import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {FulfillmentStates} from "./types/FulfillmentTypes";
import withAuth from "../../hoc/withAuth";
import Cookies from "universal-cookie";
import {fulfillmentService} from "../../services/otodisApi/FulfillmentService";
import {Button, Col, Modal, Row, Spin, Statistic} from "antd";
import {ScheduleOutlined} from "@ant-design/icons";

export interface TrackProps {
}

class Track extends Component<TrackProps & any, FulfillmentStates> {
    private readonly initState!: FulfillmentStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());

    constructor(props: TrackProps & any | any) {
        super(props);

        this.initState = {
            processing: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataConfig: {},
            processingFetchConfig: true,
            fulfillmentProcess: false,
        }
        this.state = {...this.initState}
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchConfig: true,
            dealerCode: data.value,
        });
    }

    async componentDidMount() {
        await this.fetchConfig();
    }

    fetchConfig = async () => {
        await this.promisedSetState({
            processingFetchConfig: true,
            dataConfig: {}
        });

        fulfillmentService.getConfigFulfillment()
            .then(async value => {
                await this.promisedSetState({
                    processingFetchConfig: false,
                    dataConfig: value.data.data
                });
            }).catch(async reason => {
            await this.promisedSetState({
                processingFetchConfig: false,
                dataConfig: {}
            });
        })
    }

    fetchOffer = async () => {
        this.setState({
            fulfillmentProcess: true,
        });

        const input = {
            company: "amarta",
            last_update_admin: this.user,
            update_fulfillment_update_time: false
        }
        try {
            await fulfillmentService.closingFulfillment(
                input
            ).then(successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'resync stock berhasil dibuat'
                });
                this.fetchConfig();

                this.setState({
                    fulfillmentProcess: false,
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                fulfillmentProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Fulfillment`} defaultSelectedKeys={['m-setting-fulfillment']} defaultOpenKeys={['sm-setting']}>
                    <div style={this.state.processingFetchConfig ? {} : {display: 'none'}} className={`spinCenter`}>
                        <Spin size="large"/>
                    </div>
                    <Row style={this.state.processingFetchConfig ? {display: 'none'} : {padding: 25}}>
                        <Col span={6}>
                            <Statistic title="Lock Closing Filter" value={this.state?.dataConfig?.event_status?.toString()}/>
                        </Col>
                        <Col span={6}>
                            <Statistic title="Event Time" value={this.state?.dataConfig?.event_time?.replace("T", " ")?.slice(0, -4)}/>
                        </Col>
                        <Col span={6}>
                            <Statistic title="Event Range (second)" value={this.state?.dataConfig?.event_range}/>
                        </Col>
                        <Col span={6}>
                            <Statistic title="Auto Closing Status" value={(this.state?.dataConfig?.auto_closing_status ?? false)?.toString()}/>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={12}>
                            <Button loading={this.state.fulfillmentProcess} onClick={this.fetchOffer} style={{margin: '20px'}} type={"primary"}> <ScheduleOutlined/> ReSync Amartahonda Stock</Button>
                        </Col>
                    </Row>

                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(Track), 18));
